import React, {Component, useEffect, useRef} from 'react';
import utils from "../../common/utils";
import * as HighCharts from 'highcharts';
import {Translation} from "react-i18next";
import { CalculatorFilled } from '@ant-design/icons';

function getDiffPoint(nextBuys, buys) {

}

const divStyle = {height: 'calc(100% - 30px)'}

class DeepChart extends Component {
  highChart = undefined;
  
  // componentMounted = false;
  
  constructor(props) {
    super(props);
    this.container = React.createRef();
    this.createChart = this.createChart.bind(this);
    this.createChartIfNeed = this.createChartIfNeed.bind(this);
  }
  
  componentDidMount() {
    // this.componentMounted = true;
    this.createChartIfNeed();
  }
  
  componentWillUnmount() {
    this.highChart = undefined;
    this.props.makeOrderBookEmpty();
  }
  
  componentWillReceiveProps(nextProps, nextContext) {
    if ((nextProps.coin != this.props.coin) || (nextProps.currency != this.props.currency)) {
      this.highChart = this.createChart();
    }
    
    if (utils.hash(this.props.buy) !== utils.hash(nextProps.buy)) {
      this.highChart.series[0].setData([], false);
      
      window._.forEach(nextProps.buy, (buyItem, index) => {
        // console.log(buyItem.cumulate, ': buyItem.cumulate src/components/exchange/DeepChart.js:41');
        if (index === nextProps.buy.length - 1) {
          this.highChart.series[0].addPoint([buyItem.price, buyItem.cumulate], true, false, false);
        } else {
          this.highChart.series[0].addPoint([buyItem.price, buyItem.cumulate], false, false, false);
        }
      });
      // redraw
    }
    
    if (utils.hash(this.props.sell) !== utils.hash(nextProps.sell)) {
      this.highChart.series[1].setData([], false);
      window._.forEach(nextProps.sell, (sellItem, index) => {
        // console.log(sellItem.cumulate, ': sellItem.cumulate src/components/exchange/DeepChart.js:54');
        if (index === nextProps.sell.length - 1) {
          this.highChart.series[1].addPoint([sellItem.price, sellItem.cumulate], true, false, false);
        }
        this.highChart.series[1].addPoint([sellItem.price, sellItem.cumulate], false, false, false);
      });
      // redraw
    }
    
    // this.highChart.xAxis[0].options.plotLines[0].value = nextProps.lastPrice || 0;
    // this.highChart.xAxis[0].update();
  }
  
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return utils.hash(this.props.sell) !== utils.hash(nextProps.sell) || utils.hash(this.props.buy) !== utils.hash(nextProps.buy)
      || nextProps.coin !== this.props.coin || nextProps.currency !== this.props.currency;
  }
  
  createChartIfNeed() {
    if (!this.highChart) {
      this.highChart = this.createChart();
    }
  }
  
  createChart() {
    return HighCharts.chart(this.container.current, {
      responsive: {
        rules: [{
          condition: {}
        }]
      },
      colors: ['#2b908f', '#90ee7e', '#f45b5b', '#7798BF', '#aaeeee', '#ff0066',
        '#eeaaee', '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'],
      chart: {
        backgroundColor: {
          linearGradient: {x1: 0, y1: 0, x2: 1, y2: 1},
          stops: [
            [0, '#36393D'],
            [1, '#36393D']
          ],
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063'
        },
        type: 'area',
        zoomType: 'x',
        divStyle,
        width: null,
      },
      title: {
        text: '',
        style: {
          color: '#E0E0E3',
          textTransform: 'uppercase',
          fontSize: '20px',
        }
      },
      subtitle: {
        style: {
          color: '#E0E0E3',
          textTransform: 'uppercase'
        }
      },
      xAxis: {
        gridLineColor: '#707073',
        labels: {
          style: {
            color: '#E0E0E3'
          }
        },
        minPadding: 0,
        maxPadding: 0,
        // plotLines: [{
        // 	color: '#888',
        // 	value: this.props.lastPrice,
        // 	width: 1,
        // 	label: {
        // 		// text: 'Previous matching price',
        // 		rotation: 90,
        // 		style: {
        // 			color: '#E0E0E3'
        // 		},
        // 	}
        // }],
        lineColor: '#707073',
        minorGridLineColor: '#505053',
        tickColor: '#707073',
        title: {
          // text: 'Price',
          style: {
            color: '#A0A0A3'
          }
        }
      },
      yAxis: [{
        gridLineColor: '#707073',
        lineColor: '#707073',
        minorGridLineColor: '#505053',
        tickColor: '#707073',
        tickWidth: 1,
        title: {
          text: '',
          style: {
            color: '#A0A0A3'
          }
        },
        lineWidth: 1,
        gridLineWidth: 1,
        tickLength: 5,
        tickPosition: 'inside',
        labels: {
          align: 'left',
          x: 8,
          style: {
            color: '#E0E0E3'
          },
        }
      }, {
        gridLineColor: '#707073',
        lineColor: '#707073',
        minorGridLineColor: '#505053',
        tickColor: '#707073',
        tickWidth: 1,
        title: {
          text: '',
          style: {
            color: '#A0A0A3'
          }
        },
        opposite: true,
        linkedTo: 0,
        lineWidth: 1,
        gridLineWidth: 0,
        tickLength: 5,
        tickPosition: 'inside',
        labels: {
          align: 'right',
          x: -8,
          style: {
            color: '#E0E0E3'
          },
        }
      }],
      credits: {
        enabled: false,
        // style: {
        // 	color: '#666'
        // }
      },
      labels: {
        style: {
          color: '#707073'
        }
      },
      drilldown: {
        activeAxisLabelStyle: {
          color: '#F0F0F3'
        },
        activeDataLabelStyle: {
          color: '#F0F0F3'
        }
      },
      navigation: {
        buttonOptions: {
          symbolStroke: '#DDDDDD',
          theme: {
            fill: '#505053'
          }
        }
      },
      // scroll charts
      rangeSelector: {
        buttonTheme: {
          fill: '#505053',
          stroke: '#000000',
          style: {
            color: '#CCC'
          },
          states: {
            hover: {
              fill: '#707073',
              stroke: '#000000',
              style: {
                color: 'white'
              }
            },
            select: {
              fill: '#000003',
              stroke: '#000000',
              style: {
                color: 'white'
              }
            }
          }
        },
        inputBoxBorderColor: '#505053',
        inputStyle: {
          backgroundColor: '#333',
          color: 'silver'
        },
        labelStyle: {
          color: 'silver'
        }
      },
      navigator: {
        handles: {
          backgroundColor: '#666',
          borderColor: '#AAA'
        },
        outlineColor: '#CCC',
        maskFill: 'rgba(255,255,255,0.1)',
        series: {
          color: '#7798BF',
          lineColor: '#A6C7ED'
        },
        xAxis: {
          gridLineColor: '#505053'
        }
      },
      scrollbar: {
        barBackgroundColor: '#808083',
        barBorderColor: '#808083',
        buttonArrowColor: '#CCC',
        buttonBackgroundColor: '#606063',
        buttonBorderColor: '#606063',
        rifleColor: '#FFF',
        trackBackgroundColor: '#404043',
        trackBorderColor: '#404043'
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        area: {
          fillOpacity: 0.2,
          lineWidth: 1,
          step: 'center'
        }
      },
      tooltip: {
        headerFormat: `<span style="font-size=10px;">Price: {point.key} ${this.props.currency}</span><br/>`,
        valueDecimals: 2
      },
      series: [{
        name: 'Bids',
        data: [],
        color: '#03a7a8',
      }, {
        name: 'Asks',
        data: [],
        color: '#fc5857'
      }]
    });
  }
  
  render() {
    return <Translation>
      {(t) => <div style={{height: '100%'}}>
        <div style={{
          height: 26,
          marginBottom: 4,
          background: '#202124',
          fontSize: 12,
          fontWeight: 'bold',
          textAlign: 'left',
          padding: 4,
          paddingLeft: 10,
          borderRadius: '3px 3px 0 0',
        }}>
          {t('common.depth_chart')}
        </div>
        <div style={{height: 'calc(100% - 30px)'}} ref={this.container} />
      </div>}
    </Translation>
  }
}

export default DeepChart;
